/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, RequestResult } from '#shared/api/client'
import type { VerifyPasskeyAdditionOptions, VerifyPasskeyAdditionResponses } from '../models/VerifyPasskeyAddition'
import { client } from '#shared/api/client'

/**
 * @summary `POST /api/passkeys/verify-registration`: stores the new passkey under the
 * session's account and answers `201` with it as `GET /api/passkeys` lists
 * it. The session is left as it is: the account was signed in already.
 * {@link /api/passkeys/verify-registration}
 */
export function verifyPasskeyAddition<ThrowOnError extends boolean = true>(options: Options<VerifyPasskeyAdditionOptions, ThrowOnError>): Promise<RequestResult<VerifyPasskeyAdditionResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return request({ method: 'POST', url: '/api/passkeys/verify-registration', security: [{ type: 'apiKey', name: 'cas_session', in: 'cookie' }], ...config, throwOnError: config.throwOnError ?? true }) as Promise<RequestResult<VerifyPasskeyAdditionResponses, ThrowOnError>>
}
